import { load } from "@/features/menu/i18n";
import { addRoutes } from "@/features/menu/router";

export const init = (): void => {
  load();
  addRoutes();
};
